import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import {red} from '@material-ui/core/colors'

import firebase from 'firebase';

import RecordBar from '../views/RecordBar';
import OnSnapshotController from '../controllers/OnSnapshotController';
import AsyncStorageData from '../controllers/AsyncStorageData';
import WzRecorder from '../WzRecorder';
import DokiboHeader from '../views/DokiboHeader';

import util from 'util';

const RedButton = withStyles(theme => ({
  root: {
    color: red[500],
  },
}))(Button);

const styles = theme => ({
  container: {
    paddingTop: 'calc(64px)', // header is 64px
  },
  addPromptDialog: {
    marginTop: theme.spacing(2),
    paddingBottom: '87px', // 79 for RecordBar + 8 for margin.
    overflow: 'scroll',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',

  },
  audioActions: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
  },
  audio: {
    marginTop: theme.spacing(2),
  },
  button: {
    marginRight: theme.spacing(2),
  },
  errorDiv: {
    border: `1px solid ${red[500]}`,
    background: red[100],
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    width: 'fit-content',
  }
});

class AddPrompt extends Component {
  state = {
  }

  constructor(props) {
    super(props);

    this.recorder = new WzRecorder({
      onRecordingStop: this.handleRecordingStop,
      onRecording: this.handleRecordingTick,
    });
  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
  }



  handleClickRecord = () => {
    this.recorder.toggleRecording();
    console.log('toggle recording');
  }

  handleRecordingTick = (milliseconds) => {
    this.setState({
      currentRecordingDuration: milliseconds,
    })
  }

  handleRecordingStop = (blob) => {
    console.log('handleRecordingStop')

    this.setState({
      draftAudio: {
        data: blob,
        url: URL.createObjectURL(blob),
        duration: this.state.currentRecordingDuration,
      },
      currentRecordingDuration: undefined,
    })
  }

  handleDeleteDraft = () => {
    this.setState({
      draftAudio: undefined,
    })
  }

  handleSubmit = () => {
    let storageRef = firebase.storage().ref()
      .child('prompts').child(this.promptSnapshot.id)
      .child(`audio`);

    this.setState({
      uploading: true,
    })

    storageRef.put(this.state.draftAudio.data)
    .then(snapshot => this.promptSnapshot.ref.set({
      modifiedAt: firebase.firestore.FieldValue.serverTimestamp(),
      audioPath: storageRef.fullPath,
      audioState: 'uploaded',
      durationMillis: this.state.draftAudio.duration,
      audioUploadError: firebase.firestore.FieldValue.delete(),
    }, {merge: true}))
    .then(snapshot => {
      console.log(`finished uploading audio for prompt`, this.promptSnapshot.id);
      this.setState({
        draftAudio: undefined,
        uploading: undefined,
      })
    })
    .catch(error => {
      console.log(error);

      this.setState({
        errorMessage: `Error, please send this prompt code to Andrew: ${this.promptSnapshot.id}`,
      });

      this.promptSnapshot.ref.set({
        modifiedAt: firebase.firestore.FieldValue.serverTimestamp(),
        audioUploadError: util.inspect(error),
      }, {merge: true})
    });
  }

  renderPromptsSnapshot = (snapshot) => {
    const classes = this.props.classes;

    if (snapshot === undefined || snapshot.docs === undefined) {
      return null;
    } else if (snapshot.docs.length === 0) {
      return <div className={classes.addPromptDialog}>
        <Typography variant='h6'>No prompts to record at the moment.</Typography>
      </div>
    }

    this.promptSnapshot = snapshot.docs[0];

    return (
      <div className={classes.addPromptDialog}>
        <Typography variant='body1'>{snapshot.docs.length} prompts remaining</Typography>
        <Typography variant='body1'>Topic: {this.promptSnapshot.get('topicId')}</Typography>
        <Typography variant='body1'>Record yourself saying this prompt</Typography>
        <Typography variant='body2'>Prompt: {this.promptSnapshot.get('text')}</Typography>
        {this.state.draftAudio &&
          <React.Fragment>
            <audio className={classes.audio} controls src={this.state.draftAudio.url} />
            <div className={classes.audioActions}>
              {!this.state.uploading &&
                <React.Fragment>
                  <RedButton className={classes.button} onClick={this.handleDeleteDraft}>delete draft</RedButton>
                  <Button variant='contained' color='primary' onClick={this.handleSubmit}>submit</Button>
                </React.Fragment>
              }
            </div>
            {this.state.uploading &&
              <div>
                <LinearProgress color='secondary' />
                <Typography variant='body1'>uploading...</Typography>
              </div>
            }
          </React.Fragment>
        }
        {this.state.errorMessage &&
          <div className={classes.errorDiv}>{this.state.errorMessage}</div>
        }
      </div>
    )
  }


  render() {
    const classes = this.props.classes;

    return (
      <div className={classes.conversation}>
        <DokiboHeader
          title='Dokibo | Add Prompts'
          breadcrumbs={[
            {title: 'Dokibo', href: `/`},
            {title: 'Add Prompts'}
          ]}

        />
        <div className={classes.container}>
          <OnSnapshotController
            key={firebase.firestore().collection('prompts').path}
            dbRef={firebase.firestore().collection('prompts')
                   .where('spokenBy', '==', firebase.auth().currentUser.uid)
                   .where('audioPath', '==', null)}
            >
            {data => data &&
              this.renderPromptsSnapshot(data.snapshot)
            }
          </OnSnapshotController>
          <RecordBar
            onClickRecord={this.handleClickRecord}
            isRecording={this.state.currentRecordingDuration !== undefined}
            message={<span>Tap to<br />record</span>}
            disabled={this.state.draftAudio !== undefined}
             />
        </div>
      </div>
    );
  }
}


AddPrompt.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withStyles(styles)(AddPrompt);
